"use client";

import { ItemType } from "@/graphql/schema";
import { useFlashcardSet } from "@/hooks/flashcards/useFlashcards";
import { useTrackView } from "@/hooks/views/useViewTracking";
import { omit } from "lodash-es";

const TrackFlashcardSetViewEffect = ({ flashcardSetId }) => {
    const { flashcardSet } = useFlashcardSet({ flashcardSetId });

    useTrackView({
        itemId: flashcardSetId,
        itemType: ItemType.FLASHCARDSET,
        data: omit(flashcardSet, "flashcards"),
    });

    return null;
};

export default TrackFlashcardSetViewEffect;
